import { DBConfig } from 'ngx-indexed-db';

export const indexDBConfig: DBConfig = {
    name: 'sophia-database',
    version: 1,
    objectStoresMeta: [
        {
            store: 'sophia-store',
            storeConfig: { keyPath: 'id', autoIncrement: false },
            storeSchema: [
                { name: 'value', keypath: 'value', options: { unique: false } }
            ]
        },
    ]
};